import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { useToast } from "primevue/usetoast";
import { Ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClipboardCopy',
  props: {
    container: {},
    positionClass: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const colorClasses = {
  dark: {
    containerClass: 'border-slate-800 hover:bg-gray-400',
    iconFill: 'black',
  },
  light: {
    containerClass: 'border-gray-100 hover:bg-gray-600',
    iconFill: 'white',
  },
}



const positionClass = props.positionClass ?? "top-2 right-2";
const colorClass = props.color ? colorClasses[props.color] : colorClasses.light;
const toast = useToast();

const copyToClipboard = () => {
  const container = props.container;

  if (typeof container == undefined) {
    console.error("You must provide an element to copy it's content.");
    return;
  }

  let content = "";
  // Here we must use type narrowing to avoid typescript errors
  if (container instanceof HTMLInputElement) {
    content = container.value;
  } else if (container instanceof HTMLElement) {
    content = container.innerText;
  }

  navigator.clipboard
    .writeText(content)
    .then(() => {
      toast.add({
        severity: "success",
        summary: "Succès",
        detail: "Le contenu a été copié dans le presse-papier.",
        life: 2000,
      });
    })
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(
      'absolute border-[1px] px-3 py-3 rounded-md transition-colors cursor-pointer ' +
      _unref(positionClass) + ' ' + _unref(colorClass).containerClass
    ),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard()))
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("path", {
        fill: _unref(colorClass).iconFill,
        d: "M11.4 0a.85.85 0 0 1 .622.273l2.743 3a.884.884 0 0 1 .235.602v9.25a.867.867 0 0 1-.857.875H3.857A.867.867 0 0 1 3 13.125V.875C3 .392 3.384 0 3.857 0zM14 4h-2.6a.4.4 0 0 1-.4-.4V1H4v12h10z"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        fill: _unref(colorClass).iconFill,
        d: "M3 1H2a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1h-1v1H2V2h1z"
      }, null, 8, _hoisted_3)
    ]))
  ], 2))
}
}

})